// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_t-1";
export var movingGradient = "_t-4";
export var movingGradientBlock = "_t-2";
export var skeleton = "_t-0";
export var skeletonText = "_t-3";